import React, {useEffect, useState} from "react";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import axios from 'axios';
import { useBaseUrlContext } from "../context/Base_url";
import { useAlertContext } from "../context/Alerts";
import { QueryClient, useQuery, useQueryClient } from "@tanstack/react-query";
import { useErrHandleContext } from "../context/Err_handle.js";

import {ThemeProvider, Container, Typography, Box} from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2'; 
import {ThemeCustom} from '../styles/Theme';
import 'simplebar-react/dist/simplebar.min.css';

import ButtonImgMain from "../components/button/Button_img_main";
import StatsCard from "../components/card/stats_card.js";

import NotFound from '../assets/no-results-found.svg'
import LoaderIcon from '../assets/loader2.gif'
import ClipboardIcon from '../assets/Clipboard.svg';
import ThumbsUpIcon from '../assets/Thumbs-up.svg';
import ThumbsDownIcon from '../assets/Thumbs-down.svg';
import HourglassIcon from '../assets/hourglass-start.svg';
import CloudUploadIcon from '../assets/cloud-upload.svg';
import EnvelopeOpenIcon from '../assets/envelope-open.svg';
import ClipboardCheckIcon from '../assets/clipboard-check.svg';
import BriefcaseIcon from '../assets/briefcase.svg';

const Dashboard = () => {

    const [stats, setStats] = useState([])
    const [statsTotal, setStatsTotal] = useState([])
    const [loader, setLoader] = useState(true)
    const { sucessAlert, failAlert } = useAlertContext();
    const {handleError} = useErrHandleContext()
    const { baseUrl } = useBaseUrlContext();
    const navigate = useNavigate()

    const createStatsObj = (data) => {

        const statsObj = [{id:1, icon:HourglassIcon, title:'Pending Reviews', count:data.activePendingCvCount || 0, bgColor:'rgba(255,178,7,0.2)'}, {id:2, icon:ThumbsUpIcon, title:'Shortlisted Candidates', count:data.activeShortlistedCvCount || 0, bgColor:'rgba(0,171,73,0.2)'}, {id:3, icon:ThumbsDownIcon, title:'Rejected Candidates', count:data.activeRejectedCvCount || 0, bgColor:'rgba(255,77,79,0.2)'}]

        const statsObjTotal = [{id:1, icon:ClipboardCheckIcon, title:'Processed CVs', count:data.processedCvCount || 0, bgColor:'#0070FF'},  {id:2, icon:EnvelopeOpenIcon, title:'Email Imports', count:data.processedViaEmailCvCount || 0, bgColor:'#232323'}, {id:3, icon:CloudUploadIcon, title:'Uploaded CVs', count:data.manuallyProcessedCvCount || 0, bgColor:'#232323'}, {id:4, icon:BriefcaseIcon, title:'Created Jobs', count:data.jdCount || 0, bgColor:'#232323'},]

        setStats(statsObj)
        setStatsTotal(statsObjTotal)

        console.log('xxx', data)
        
    }

    //get dashboard details

    const fetchDashboardData = async ({queryKey}) => {

        const [_key] = queryKey
        console.log('queryKey > ', queryKey)

            try{

                const header = {
                    'Authorization': localStorage.getItem('token')
                }
               
                const response = await axios.get(`${baseUrl}/dashboard/indexes`, {headers:header})

                const res = response.data
                console.log('res', response);
    
                if(res.code === 200){
                    console.log('dashboard', res.data)
                    setLoader(false)
                    return res.data;
                }
                else{
                    failAlert(true, res.message)
                    setLoader(false)
                    throw new Error(res.message)
                }

            } catch(error) {
                //failAlert(true, error.message)
                handleError(error)
                setLoader(false)
                return [];
            }
        
    }

    //useQuery hook for get dashboard detail

    const {isLoading, data:dashboardData} = useQuery({

        queryKey: ['fetchDashboardData'],
        queryFn: fetchDashboardData,
        cacheTime: 30 * 60 * 1000,

    })

    useEffect(()=>{
        if(dashboardData){
            createStatsObj(dashboardData)
        }
    },[dashboardData])


    return(
        <ThemeProvider theme={ThemeCustom}>

            <Container maxWidth="xl" className="mt-20 mb-5 pt-5">
                <div className="mb-7 flex justify-between items-center">
                    <Typography variant="textheader2" component={'div'}>Dashboard</Typography>
                    <ButtonImgMain 
                        variant='primary' 
                        type='button' 
                        disabled={false} 
                        name='Job Board'
                        class='capitalize'
                        img={ClipboardIcon}
                        posision={'right'}
                        onClick={()=>navigate(`/job-board`)}
                    />
                </div>
                <SimpleBar className="job-board-height rounded-xl p-0 m-0">
                    {stats.length > 0 ? (
                    <>
                    <Typography component={'div'} variant="textheaderSub2DarkGray" className="mb-5">Overall CV Management</Typography>
                    <div className="card-container bg-white rounded-xl w-full py-5 mb-7 flex justify-between items-center">
                        {statsTotal.length > 0 && statsTotal.map((tot, index)=>(
                            <div key={index} className={`flex items-start justify-start w-1/4 px-5 py-2 ${statsTotal.length !== index+1 ? ' border-r border-r-cultured border-solid border-0':''}`}>
                                <Box className={`flex justify-centeritems-center rounded-full p-4`} sx={{bgcolor: tot.bgColor}}>
                                    <img src={tot.icon} alt={`${tot.title} icon`} className="w-8 h-8"/>
                                </Box>
                                <div className="flex flex-col ml-7">
                                    <Typography component={'div'} variant="textheader4" className="text-grayLight font-medium truncate min-h-[1.5rem]">{tot.title}</Typography>
                                    <Typography component={'div'} variant="textheader2" className="truncate">{tot.count}</Typography>
                                </div>
                            </div>
                        ))}
                    </div>
                        <Typography component={'div'} variant="textheaderSub2DarkGray" className="mb-5"> Review Status</Typography>
                        <Grid container columnSpacing={2}>
                            {stats.map((stat, index)=>(
                                <Grid sm={4} xs="auto" key={stat.id} className={'px-2'}>
                                    <StatsCard 
                                        icon={stat.icon}
                                        title={stat.title} 
                                        count={stat.count}
                                        bgColor={stat.bgColor}
                                    />
                                </Grid>
                            ))}
                           
                        </Grid>
                    </>
                    ):(
                        loader ? (
                            <div className="w-full flex-col flex justify-center items-center review-unselected">
                                <img src={LoaderIcon} alt="loading" className="w-[4rem] mb-5"/>
                                <Typography variant="textheader3" component={'div'}>Loading...</Typography>
                            </div>
                        ):(
                            ''
                        )
                    )} 
                </SimpleBar>
            </Container>
        </ThemeProvider>
        
    )
}

export default Dashboard